import { Component, Inject, NgZone } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { IS_SAAS } from "@coso/utility";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { ServiceStatus, GroupStorage, HighAvailabilityModes } from "../../../../models";
import { AUserPermissionsService } from "../../../../services/a-user-permissions.service";
import { isRunning } from "../../../../utils/is-running";

@Component({
  standalone:false,
  templateUrl: "./list-configurations-actions-cell-renderer.component.html"
})
export class ListConfigurationsActionsCellRendererComponent implements ICellRendererAngularComp {
  ServiceStatus = ServiceStatus;
  GroupStorage = GroupStorage;
  HighAvailabilityModes = HighAvailabilityModes;

  params: ICellRendererParams;
  data: any;
  isReadOnly: boolean;
  isRunning: boolean;
  isCustomerAgent: boolean;
  bStartStopEnabled: boolean;

  token: string;

  constructor(
    @Inject(IS_SAAS) public isSaaS: boolean,
    private userPermissionsService: AUserPermissionsService,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = params.data;
    this.isReadOnly = params.context.parentComponent.isReadOnly;
    this.isRunning = isRunning(params.data.status);
    this.bStartStopEnabled =
      params.data.status === ServiceStatus.Started ||
      params.data.status === ServiceStatus.BackupStandBy ||
      params.data.status === ServiceStatus.InitialLoading ||
      params.data.status === ServiceStatus.Stopped;

    this.userPermissionsService.isCustomerAgent$.subscribe((isCustomerAgent) => (this.isCustomerAgent = isCustomerAgent));
  }

  startStopReplication() {
    this.bStartStopEnabled = false;
    this.ngZone.run(() => {
      if (this.isRunning) {
        this.params.context.parentComponent.stopReplication(this.data);
      } else {
        this.params.context.parentComponent.startReplication(this.data);
      }
    });
  }

  confirmDeletion() {
    this.ngZone.run(() => this.params.context.parentComponent.confirmDeletion(this.data));
  }

  forceFullIteration() {
    this.ngZone.run(() => this.params.context.parentComponent.forceFullIteration(this.data));
  }

  clearSpPermissionsCache() {
    this.ngZone.run(() => this.params.context.parentComponent.clearSpPermissionsCache(this.data));
  }

  clearSpGroupCache() {
    this.ngZone.run(() => this.params.context.parentComponent.clearSpGroupCache(this.data));
  }

  clearSdkMessageProcessingSteps() {
    this.ngZone.run(() => this.params.context.parentComponent.clearSdkMessageProcessingSteps(this.data));
  }

  resetIssues() {
    this.ngZone.run(() => this.params.context.parentComponent.resetIssues(this.data));
  }

  /** ICellRendererAngularComp runs outside the zone. This makes sure that navigation triggered will run in the zone. */
  navigateTo(event: UIEvent, urlParts: string[]) {
    event.preventDefault();
    this.ngZone.run(() => this.router.navigate(urlParts, { relativeTo: this.route }));
  }
}
